import type { User as FirebaseUser } from 'firebase/auth';

export const mergeFetchedClaims = async (firebaseUser: FirebaseUser) => {
  const tokenResult = await firebaseUser.getIdTokenResult();
  return { ...firebaseUser, claims: tokenResult.claims };
};
